
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightningHeavySnowShowersPolartwilightColour as ObiLightningHeavySnowShowersPolartwilightColourElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-lightning-heavy-snow-showers-polartwilight-colour.js';
 
 
 

 
 export const ObiLightningHeavySnowShowersPolartwilightColour = createComponent({
   react: React,
   tagName: 'obi-lightning-heavy-snow-showers-polartwilight-colour',
   elementClass: ObiLightningHeavySnowShowersPolartwilightColourElement,
   events: {
     
   }
  });
 
 